import React, { useState } from "react";
import apiEndpoints from "../../../../store/apiEndpoints";
import errorFunctions from "../../../../store/errorFunctions";
import { useToast } from "../../../../components/Toast/ToastContext";
import { MdEdit } from "react-icons/md";
import { DoaModal } from "./DoaModal";

export default function DoaStatus({ details, userInfo, protectedFetch, retrieveWarranty }) {
  const { showToast } = useToast();
  const [doaModalOpen, setDoaModalOpen] = useState(false);

  const handleSubmitDoa = (value) => {
    if (value === null) {
      showToast("Please select DOA or Non-DOA", "warning");
      return;
    }
    const payload = { dead_on_arrival: value };
    protectedFetch(
      apiEndpoints.ticket.setDoa(details?.id),
      "PATCH",
      payload,
      errorFunctions.checkResponseThenJson,
    )
      .then(() => {
        showToast("DOA status updated successfully", "success");
        retrieveWarranty?.(details?.id);
        setDoaModalOpen(false);
      })
      .catch((err) => {
        console.log("fail DOA update", err);
        showToast("Failed to update DOA status", "error");
      });
  };

  const isCommercial = ["Commercial Staff", "Commercial Admin"].includes(userInfo?.user?.role);
  const isApproved = !details?.status?.includes("Pending Approval");
  const canEdit = isApproved && !isCommercial;

  const doaBadgeClass =
    details?.dead_on_arrival === true ? "bg-danger" :
    details?.dead_on_arrival === false ? "bg-success" : "bg-secondary";

  const doaLabel =
    details?.dead_on_arrival === null || details?.dead_on_arrival === undefined
      ? "Not Set"
      : details?.dead_on_arrival ? "Yes" : "No";

  return (
    <>
      <div className={"single-warranty-details-item"}>
        <span className={"single-warranty-details-label"}>Dead On Arrival (DOA):</span>
        <div className="doa-status-row">
          <span className={`badge ${doaBadgeClass}`}>{doaLabel}</span>
          {canEdit && (
            <button
              type="button"
              className="doa-edit-btn"
              onClick={() => setDoaModalOpen(true)}
              title="Edit DOA status"
            >
              <MdEdit />
            </button>
          )}
        </div>
      </div>

      <DoaModal
        isOpen={doaModalOpen}
        currentValue={details?.dead_on_arrival ?? null}
        onSave={handleSubmitDoa}
        onClose={() => setDoaModalOpen(false)}
      />
    </>
  );
}
